import * as React from 'react'
import { PropsWithChildren, ReactElement, ReactNode } from 'react'
import { FontWeights, IFontStyles, IStyle, mergeStyleSets, Stack, Text } from '@fluentui/react'

export type LabelValueProps = {
    label?: ReactNode
    value?: ReactNode
    prefix?: ReactNode
    suffix?: ReactNode
    indent?: number
    wrap?: boolean

    labelVariant?: keyof IFontStyles
    labelStyles?: IStyle
    valueVariant?: keyof IFontStyles
    valueStyles?: IStyle
}

export default function LabelValue(props: PropsWithChildren<LabelValueProps>): ReactElement {
    const classNames = mergeStyleSets({
        stack: { minWidth: 0 },
        label: [{ fontWeight: FontWeights.regular }, props.labelStyles],
        value: [{ fontWeight: FontWeights.regular }, props.valueStyles],
        prefix: [{ paddingRight: '.5em' }, props.valueStyles],
        suffix: [{ paddingLeft: '.5em' }, props.valueStyles],
    })

    if ((props.value === undefined || props.value === null || props.value === '') && !props.children) {
        return <></>
    }

    return (
        <Stack tokens={{ childrenGap: 0 }} verticalAlign="baseline" className={classNames.stack}>
            {props.label && (
                <Text variant={props.labelVariant || 'smallPlus'} className={classNames.label}>
                    {props.label}
                </Text>
            )}
            <Text variant={props.valueVariant || 'mediumPlus'} className={classNames.value}>
                {props.prefix && <small className={classNames.prefix}>{props.prefix}</small>}
                {props.value === 0 ? 0 : props.value || props.children}
                {props.suffix && <small className={classNames.suffix}>{props.suffix}</small>}
            </Text>
        </Stack>
    )
}
